import FirstPartActiveIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/FirstPartActive.svg?react';
import SecondPartActiveIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/SecondPartActive.svg?react';
import SecondPartInActiveIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/SecondPartInactive.svg?react';
import FirstPartInActiveIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/FirstPartInactive.svg?react';
import { StepType } from '@/modules/adjusterReportModules/IncidentParticipants/components/common/Stepper.type';
export const VehicleInformationStepperData: StepType[] = [
  {
    label: 'قسمت اول',
    icon: <FirstPartInActiveIcon />,
    activeIcon: <FirstPartActiveIcon />,
    path: 'vehicle-information',
  },
  {
    label: 'قسمت دوم',
    icon: <SecondPartInActiveIcon />,
    activeIcon: <SecondPartActiveIcon />,
    path: 'part-two',
  },
];
